import type { CapacityInfo } from './api';
const clock = (value: string) => new Date(value).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
export function CapacityBanner({ capacity, staleAsOf }: { capacity: CapacityInfo; staleAsOf: string | null }) {
  return <div className="ratelimit-banner" role="status" aria-live="polite">
    <div className="ratelimit-banner-body">
      <p>{capacity.message}</p>
      {staleAsOf && <p>Saved snapshot from {clock(staleAsOf)}. Promotion checks are verified again when requested.</p>}
      {capacity.retryAt && <p>Refresh can resume after {clock(capacity.retryAt)}.</p>}
    </div>
  </div>;
}
